import { getCurrentUser as getCurrentUserApi } from '@/app/apis';
import { livesGetEmergencyContact, livesSubmitEmergencyContact } from '@/app/services/live';
import type { LiveV1SubmitEmergencyContactRequest } from '@/app/services/live/types.gen';
import { creationsGetShareDetail, creationsGetShareToken, usersGetMyStat } from '@/app/services/vidu';

export const getCurrentUser = getCurrentUserApi;
export const getStreamProfile = () => usersGetMyStat();
export const getLiveEmergencyContact = () => livesGetEmergencyContact();
export const submitLiveEmergencyContact = (body: LiveV1SubmitEmergencyContactRequest) =>
  livesSubmitEmergencyContact({ body });
export const getOfflineAvatarCreationShareToken = (creationId: string) =>
  creationsGetShareToken({ path: { id: creationId }, body: {} });
export const getOfflineAvatarCreationShareDetail = (creationId: string, token?: string) =>
  creationsGetShareDetail({ path: { id: creationId }, query: { token } });
